class ClcNewFooter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector(".clc-footer__newsletter-form");
    this.status = this.querySelector("[data-clc-footer-form-status]");

    this.form?.addEventListener("submit", this.handleFormSubmit);

    if (this.status) {
      this.status.setAttribute("tabindex", "-1");
      this.status.focus();
    }
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.handleFormSubmit);
  }

  handleFormSubmit = () => {
    const button = this.form?.querySelector("[data-clc-footer-newsletter-submit]");

    if (!button) {
      return;
    }

    button.setAttribute("aria-busy", "true");
    button.disabled = true;
  };
}

if (!customElements.get("clc-new-footer")) {
  customElements.define("clc-new-footer", ClcNewFooter);
}
